import moment from 'moment';

const DEADLINES = {
  LATE: 'LATE',
  UPCOMING: 'UPCOMING',
  CURRENT: 'CURRENT',
  UNDEFINED: 'UNDEFINED'
};

const DEADLINES_CLASSES = {
  LATE: {
    bg: 'bg-red-50 hover:bg-red-100',
    text: 'text-red-600'
  },
  CURRENT: {
    bg: 'bg-amber-50 hover:bg-amber-100',
    text: 'text-amber-600'
  },
  UPCOMING: {
    bg: 'bg-slate-50 hover:bg-slate-100',
    text: 'text-slate-600'
  },
  UNDEFINED: {
    bg: 'bg-slate-50',
    text: 'text-slate-600'
  }
};

const deadlineClasses = (date, bypass) =>
  DEADLINES_CLASSES[resolveDeadline(date, bypass) || 'UNDEFINED'];

const resolveDeadline = (date = null, bypass = false) => {
  if (!date || bypass) return;

  const d = moment(date);
  const now = moment();

  if (!d.isValid()) {
    return;
  }

  if (d.isBefore(now.startOf('day'))) return DEADLINES.LATE;

  if (d.isSameOrBefore(now.endOf('week'))) return DEADLINES.CURRENT;

  return DEADLINES.UPCOMING;
};

export { deadlineClasses, resolveDeadline, DEADLINES };
